import { render, staticRenderFns } from "./FileTypeMixin.js.vue?vue&type=template&id=1ed895e5&"
import script from "./FileTypeMixin.js.vue?vue&type=script&lang=js&"
export * from "./FileTypeMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports